import { useRef } from "react";
import SpecialText from "./SpecialText";
import Image from "../fragments/Image";
import { useReveal } from '../hooks/UseReveal';

export default function ThumbnailQuote({ quote }) {

    const revealRef = useReveal({ once: true });

    return (

        <div className="c-quote-thumbnail">
            <div className="c-heading c-heading--accent c-quote-thumbnail__inner c-transition-in" ref={revealRef}> 
                <SpecialText text={quote.text} className="c-quote-thumbnail__quote c-heading c-heading--accent" />
            </div>
        </div>

    )
}